const getters = {
  theme: state => state.common.theme,
  themeName: state => state.common.themeName,
  isFullScren: state => state.common.isFullScren,
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  device: state => state.app.device,
  token: state => state.user.token,
  userName: state => state.user.name,
  profile: state => state.user.profile,
  userId: state => state.user.userId,
  orgId: state => state.user.orgId,
  userType: state => state.user.userType,
  orgType: state => state.user.orgType,
  orgName: state => state.user.orgName,
  menus: state => state.user.menus,
  operationPerms: state => state.user.operationPerms,
  setting: state => state.user.setting,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  errorLogs: state => state.errorLog.logs,
  rangeList: state => state.user.rangeList
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js